import { useEffect, useState } from 'react';

export function usePortfolio() {
  const [portfolio, setPortfolio] = useState(null);
  useEffect(() => {
    const p = localStorage.getItem('portfolio');
    setPortfolio(p ? JSON.parse(p) : null);
  }, []);
  return [portfolio, setPortfolio];
}

export function addInvestmentToPortfolio(newInv) {
  const p = localStorage.getItem('portfolio');
  if (!p) return;
  const portfolio = JSON.parse(p);
  portfolio.investments = [...(portfolio.investments || []), newInv];
  // recalcul des totaux
  portfolio.investmentTotalAmountEur = portfolio.investments.reduce((sum, i) => sum + (i.investmentAmountEur || 0), 0);
  portfolio.currentTotalAmountEur = portfolio.investments.reduce((sum, i) => sum + (i.currentAmountEur || 0), 0);
  localStorage.setItem('portfolio', JSON.stringify(portfolio));
}
